import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const TextInputAddon = ({ content, disabled, }) => {
    const textInputAddonStyles = useMemo(() => (css `
        ${styleUtils.borderBox}
        ${theme.typeStyles.bodyMediumStyles}
        align-items: center;
        border: none;
        color: ${theme.colors.gray600};
        cursor: default;
        display: flex;
        height: 100%;
        padding: 0 ${theme.spacing.x3};
        white-space: nowrap;
        border-color: transparent;
        ${disabled && css `
          color: ${theme.colors.gray500};
          background-color: ${theme.colors.gray200};
        `}
      `), [
        disabled,
    ]);
    return (_jsx("div", Object.assign({ css: textInputAddonStyles }, { children: content })));
};
export { TextInputAddon };
